import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class PlatformQuestion extends Phaser.GameObjects.Image {
  constructor(scene, x, y) {
    super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, 'PlatformQuestion');

    this.setOrigin(0);

    this.isActive = false;
    this.jumpedOn = false;
    this.despawning = false;
    this.questionDisplayRef = null;
    this.settleY = this.scene.scale.height - 112;

    scene.physics.add.existing(this);

    this.body.setImmovable(true);
    this.body.checkCollision.up = true;
    this.body.checkCollision.left = false;
    this.body.checkCollision.right = false;
    this.body.checkCollision.down = false;

    this.visible = false;
    this.active = false;
    this.body.enable = false;

    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this));
  }

  spawn(x,y, vy) {
    this.setPosition(x + this.width / 2, y + this.height / 2);
    this.body.reset(x + this.width / 2, y + this.height / 2);
    this.body.setImmovable(true);

    this.body.checkCollision.up = true;
    this.body.checkCollision.left = false;
    this.body.checkCollision.right = false;
    this.body.checkCollision.down = false;

    this.inPlace = false;
    this.visible = true;
    this.isActive = true;
    this.active = true;
    this.despawning = false;
    this.body.enable = true;

    this.body.setVelocity(0);
    this.body.velocity.y = vy;
  }

  releaseAfterCorrectAnswer() {
    this.despawning = true;
  }

  setToMoveOn() {
    this.despawning = true;
    this.isActive = false;
    this.inPlace = false;
    this.active = false;
    this.visible = false;
    this.body.enable = false;
  };

  despawn() {
    this.setPosition(0,200);
    this.body.velocity.y = 0;
    this.despawning = false;
    this.jumpedOn = false;
    this.visible = false;
    this.inPlace = false;
    this.active = false;
    this.body.enable = false;
  };

  setGravity() {
    this.isActive = false;
    this.body.immovable = false;
    this.body.moves = true;

    this.body.checkCollision.up = true;
    this.body.checkCollision.left = true;
    this.body.checkCollision.right = true;
    this.body.checkCollision.down = false;
  };

  update() {
    if (this.questionDisplayRef.tiedToPlatform) {
      this.questionDisplayRef.y = this.body.y - 750;
    }
    if (!this.isActive) return;

    if (!this.despawning && this.body.y >= this.settleY) {
      this.body.velocity.y = 0;

      if (!this.inPlace) this.body.y = this.settleY;
      this.inPlace = true;
    }
    else if (this.despawning) {
      if (this.body.y >= this.scene.scale.height + 750) {
        this.despawning = false;
        this.isActive = false;
        this.visible = false;
        this.body.enable = false;
      }
    }

    if (this.questionDisplayRef.tiedToPlatform) {
      this.questionDisplayRef.y = this.body.y - 750;
    }
  }
}